import * as React from 'react';
import { InjectedRouter } from 'react-router';

import BoxBody from 'components/BoxBody';
import Button from 'components/ButtonDeprecated';
import DialogContent from 'components/DialogContent';
import FormDeprecated from 'components/FormDeprecated';
import FormInput from 'components/FormInput';
// @ts-ignore
import RecipientParser from 'lib/RecipientParser';
// @ts-ignore
import UserActions from 'user/UserActions';
// @ts-ignore
import User from 'entities/User';
import { withRouter } from 'app/context/Router';

type Props = {
  onDone: (user: User) => void;
  onError: (err: any) => void;
  router: InjectedRouter;
  location: any;
};

type State = {
  canSubmit: boolean;
};

export class JoinInfoPageParentEmail extends React.Component<Props, State> {
  state = {
    canSubmit: false,
  };

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  submit = (attrs: any) => {
    const token = RecipientParser.newToken(attrs.address);

    UserActions.addParent(attrs.full_name, token.address).then((user: User) => {
      // onDone gets passed into this component via JoinInfoPage
      // but not via setup routes, so we need to manually reroute
      // the user to progress to the next step
      if (this.props.onDone) {
        this.props.onDone(user);
      } else {
        this.props.router.push(this.props.location?.state?.location ?? '/');
      }
    }, this.props.onError);
  };

  render() {
    return (
      <DialogContent
        size="small"
        className="JoinInfoPageParentEmail"
        title="Enter your parent’s name and contact information"
        subtext="They’ll be added to Remind and get the same messages you do.">
        <BoxBody divided>
          <FormDeprecated
            onValid={this.enableButton}
            onInvalid={this.disableButton}
            onValidSubmit={this.submit}>
            <FormInput
              label="Parent’s full name"
              required
              name="full_name"
              showErrorOnPristine={false}
              placeholder="First and last name"
              validations={{
                maxLength: 255,
              }}
              validationErrors={{
                maxLength: 'Name should be shorter than 255 characters.',
              }}
            />
            <FormInput
              label="Contact information"
              type="text"
              name="address"
              placeholder="Phone number or email address"
              validations="isEmailOrPhone"
              validationError="Invalid phone or email"
              showErrorAfterBlur
            />
            <Button disabled={!this.state.canSubmit} type="submit">
              Done
            </Button>
          </FormDeprecated>
        </BoxBody>
      </DialogContent>
    );
  }
}

export default withRouter(JoinInfoPageParentEmail);
